import { Link } from 'react-router-dom'
import { PATHS } from '../../../shared/config/paths'
import { SegmentedControl } from '../../../shared/ui/controls/SegmentedControl'
import type { GuideStepContent } from '../content/guideStep'
import { useGuideDevice } from '../model/useGuideDevice'
import { GuideStep } from './GuideStep'
import { PhaseRail } from './PhaseRail'

type Props = { title: string; intro: string; steps: GuideStepContent[] | Record<'android' | 'ios', GuideStepContent[]> }

export const DeviceStepsTopic = ({ title, intro, steps: stepsByDevice }: Props) => {
  const { device, setDevice } = useGuideDevice()
  const isSplit = !Array.isArray(stepsByDevice)
  const steps = Array.isArray(stepsByDevice) ? stepsByDevice : stepsByDevice[device]

  return (
    <>
      <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
      <p className="mb-6 mt-1 text-base text-gray-600">{intro}</p>

      {isSplit && (
        <SegmentedControl
          ariaLabel="Gerät"
          value={device}
          onChange={(v) => setDevice(v)}
          items={[
            { label: 'Android', value: 'android' },
            { label: 'iPhone', value: 'ios' },
          ]}
        />
      )}

      <div className={isSplit ? 'mt-6' : undefined}>
        {steps.map((step, i) => (
          <PhaseRail key={step.title} number={i + 1} title={step.title} isLast={i === steps.length - 1}>
            <GuideStep step={step} />
          </PhaseRail>
        ))}
      </div>

      <div className="mt-10 flex flex-wrap items-center gap-3 border-t border-gray-200 pt-6 text-base">
        <Link to={PATHS.userGuide} className="text-primary hover:underline">
          ← Zurück zur Übersicht
        </Link>
      </div>
    </>
  )
}
